import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormOctagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormOctagon"><Path d="M15.935 2.5L21.5 8.06497V15.935L15.935 21.5H8.06497L2.5 15.935L2.5 8.06497L8.06497 2.5L15.935 2.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFormOctagon;
